import {
    ColoursObj,
    Gutters,
    MobileConfirmDialog,
    TDialogStore,
    useDialogStore,
    useValidatorContext,
} from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useEffect } from 'react'
import { useShallow } from 'zustand/react/shallow'
import i18n from '../../i18n/i18next'
import { bs, useBoundStore } from '../../state/bound.store'
import { defaultAddSnack } from '../../state/overlayState/overlayContext'
import { NavigationView } from '../layout/NavigationView'
import { ComponentFinderEdit } from './componentFinderEdit'
import { useEditSectionContext } from './editSectionProvider'

export const CreateNewItineraryDynamic = () => {
    const { values } = useEditSectionContext()
    const { onCancelEdit, anyPendingChanges } = useEditSectionContext()
    const { replaceDialog, clearDialog }: TDialogStore = useDialogStore(
        useShallow((s: TDialogStore) => ({
            clearDialog: s.clearDialog,
            replaceDialog: s.replaceDialog,
        }))
    )

    const section = bs().sections?.find((section) => {
        return section.id === 1
    })

    const { setValidationOn, setShowErrors, isAllValid } = useValidatorContext()

    useEffect(() => {
        setValidationOn(true)
    }, [])

    const onBackPressed = () => {
        if (anyPendingChanges) {
            replaceDialog({
                node: (
                    <MobileConfirmDialog
                        text={i18n.t(
                            'edit-itinerary.item.unsaved-booking-text'
                        )}
                        header={i18n.t('edit-itinerary.item.pending-changes')}
                        onConfirm={handleDialogConfirm}
                        onCancel={() => {
                            clearDialog()
                        }}
                        cancelText={i18n.t('general.cancel')}
                        confirmText={i18n.t('general.leave')}
                    />
                ),
                backdropClosable: false,
            })
        } else {
            setShowErrors(false)
            setValidationOn(false)
            window.goBack()
        }
    }

    const handleDialogConfirm = () => {
        clearDialog()
        setShowErrors(false)
        setValidationOn(false)
        onCancelEdit?.()
        window.goBack()
    }
    return (
        <>
            <NavigationView
                usePageTransition
                backButtonAction={onBackPressed}
                navigationBarTitle={i18n.t('home.new-itinerary')}
                navigationBarTrailing={[
                    {
                        id: 'saveButton',
                        buttonText: i18n.t('general.done'),
                        colour: ColoursObj.core.primary,
                        useButton: true,
                        action: async () => {
                            if (anyPendingChanges) {
                                if (!isAllValid) {
                                    setShowErrors(true)
                                    return
                                }
                                const resp = await useBoundStore
                                    .getState()
                                    .createItinerary(values)
                                if (resp) {
                                    window.pushPath('/')
                                } else {
                                    defaultAddSnack(
                                        'Failed to create itinerary. Please make sure all details entered are correct.',
                                        'error'
                                    )
                                    window.pushPath('/')
                                }
                            }
                        },
                    },
                ]}
            >
                <Gutters style={{ height: '100%' }}>
                    <Stack spacing="16px" height="100%">
                        <Stack gap="16px">
                            {section &&
                                section.properties.mobileEditFieldOptions.components.map(
                                    (option: any, index: number) => {
                                        return (
                                            <Stack key={index}>
                                                <ComponentFinderEdit
                                                    _id="0"
                                                    editComponent={option}
                                                />
                                            </Stack>
                                        )
                                    }
                                )}
                        </Stack>
                        <div />
                    </Stack>
                </Gutters>
            </NavigationView>
        </>
    )
}
